export default __webpack_public_path__ + "static/media/Mordec Blade.76dc63a5.jpg";